import script from "./MTournament.vue?vue&type=script&setup=true&lang=ts"
export * from "./MTournament.vue?vue&type=script&setup=true&lang=ts"

import "./MTournament.vue?vue&type=style&index=0&id=f9aec47e&lang=less"

const __exports__ = script;

export default __exports__